import { jsxs, jsx } from "react/jsx-runtime";
const IconArrowUpRightSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M15.433 5.517a.834.834 0 0 0-.45-.45.834.834 0 0 0-.316-.067H6.333a.833.833 0 0 0 0 1.667h6.325l-6.916 6.908a.833.833 0 0 0 0 1.183.833.833 0 0 0 1.183 0l6.908-6.916v6.325a.833.833 0 0 0 1.667 0V5.833a.833.833 0 0 0-.067-.316Z" })
    ]
  }
);
export {
  IconArrowUpRightSvg
};
